if (!window.Marquee) {
  class Marquee extends HTMLElement {
    constructor() {
      super();
  
      this.selectors = {
        pause: '[js-marquee-pause]',
        entries: '[js-marquee-entries]'
      }
    }
  
    connectedCallback() {
      this.pauseMarquee = this.querySelector(this.selectors.pause);
      this.pauseMarquee.addEventListener('click', this.toggleAnimation);
      this.entries = this.querySelectorAll(this.selectors.entries);
    }

    disconnectedCallback() {
      this.pauseMarquee.removeEventListener('click', this.toggleAnimation)
    }
  
    toggleAnimation = () => {
      this.entries.forEach(entry => {
        entry.classList.toggle('animate-marquee-scroll')
      })
    }
  }
  
  window.Marquee = Marquee; // Make Carousel globally accessible

  if (!customElements.get('s-marquee')) {
    customElements.define('s-marquee', Marquee);
  }
}